import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRatewareCalcUomCode extends Layout {
    sourceRatewareCalcUomCode: DataSource;
    textboxEdiStandardCode: Textbox;
    textboxFieldCode: Textbox;
    textboxFieldCodeDesc: Textbox;
    textboxFieldName: Textbox;
    textboxFieldTableAlias: Textbox;
}
